import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { FormControlLabel, Modal, Radio, RadioGroup } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import { bindActionCreators } from 'redux';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import ShopContact from '../organisms/ShopContact';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  UPDATE_GOCHI_KID_FLAG_SHOP_SUCCESS,
  getShops,
  updateGochiKidFlagShop
} from '../../actions/Shop';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import HelpGochiKidShopDialog from '../../components/molecules/HelpGochiKidShopDialog';
import HelpQrUserKidShopDialog from '../../components/molecules/HelpQrUserKidShopDialog';
import ConfirmGochiKidFlagShopDialog from '../../components/molecules/ConfirmGochiKidFlagShopDialog';

const styles = theme => ({
  root: {
    backgroundColor: '#fff',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  mainPaper: {
    margin: 15
  },
  pageTitileDiv: {
    paddingLeft: 16,
    paddingTop: 23,
    textAlign: 'left'
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 24
  },
  mainModal: {
    zIndex: '99999!important'
  },
  buttonWrapper: {
    padding: '20px 20px 1px 20px',
    marginBottom: 39
  },
  button: {
    width: '100%',
    marginBottom: '19px',
    fontSize: 14,
    fontWeight: 'bold'
  },
  supportTimeTxt: {
    fontSize: 14,
    margin: '0 15px 15px'
  },
  twoItems: {
    display: 'flex'
  },
  ml5: {
    marginLeft: 5
  },
  mr5: {
    marginRight: 5
  },
  iconHelpEx: {
    color: 'gray !important',
    width: '20px',
    height: '20px'
  },
  textHelpTitle: {
    color: '#808080',
    fontSize: '14px',
    fontWeight: 700,
    verticalAlign: 'middle'
  },
  buttonHelp: {
    justifyContent: 'flex-start',
    backgroundColor: 'transparent',
    minWidth: 'fit-content'
  },
  radioLine: {
    padding: 4,
    marginRight: 0
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name,
      shopDetail:
        state.shops.shops && state.shops.shops.length > 0
          ? state.shops.shops[0]
          : null
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getShops, updateGochiKidFlagShop },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openShopContact', 'setOpenShopContact', false),
  withState('openHelpGochiKid', 'setOpenHelpGochiKid', false),
  withState('openHelpQrUserKid', 'setOpenHelpQrUserKid', false),
  withState('openConfirmGochiKidFlag', 'setOpenConfirmGochiKidFlag', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('openConfirm', 'updateOpenConfirm', false),
  withState('loading', 'setLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('gochiKidFlag', 'setGochiKidFlag', props => {
    return props.shopDetail && props.shopDetail.gochiKidFlag;
  }),
  withState('gochiKidQrFlag', 'setGochiKidQrFlag', props => {
    return props.shopDetail && props.shopDetail.gochiKidQrFlag;
  }),
  withState('joinGochiKidFlag', 'setJoinGochiKidFlag', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleGetDetailShop: props => async () => {
      await props.actions
        .getShops({
          shopId: props.account.shopId,
          limit: 1,
          page: 1
        })
        .then(shopData => {
          if (shopData.error === true && shopData.payload.status === 403) {
            sendLogin(props);
          }
          props.setResultMessage('');
        })
        .catch(() => {
          props.setErrorMessage('システムエラーが発生しました。');
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    actions,
    name,
    handleRedirect,
    openShopContact,
    setOpenShopContact,
    handleGetDetailShop,
    openProgress,
    updateOpenProgress,
    openConfirm,
    updateOpenConfirm,
    errorMessage,
    setErrorMessage,
    resultMessage,
    setResultMessage,
    loading,
    setLoading,
    shopDetail,
    gochiKidFlag,
    setGochiKidFlag,
    checkSession,
    openHelpGochiKid,
    setOpenHelpGochiKid,
    openHelpQrUserKid,
    setOpenHelpQrUserKid,
    joinGochiKidFlag,
    setJoinGochiKidFlag,
    gochiKidQrFlag,
    setGochiKidQrFlag,
    openConfirmGochiKidFlag,
    setOpenConfirmGochiKidFlag
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    const getShopDetail = async () => {
      updateOpenProgress(true);
      setLoading(true);
      await handleGetDetailShop();
      setLoading(false);
      updateOpenProgress(false);
    };

    useEffect(() => {
      getShopDetail();
    }, []);

    useEffect(() => {
      if (shopDetail) {
        if (shopDetail.gochiKidFlag === 0 && shopDetail.gochiKidQrFlag === 0) {
          setJoinGochiKidFlag(0);
        } else if (
          shopDetail.gochiKidFlag === 1 &&
          shopDetail.gochiKidQrFlag === 1
        ) {
          setJoinGochiKidFlag(1);
        } else if (
          shopDetail.gochiKidFlag === 1 &&
          shopDetail.gochiKidQrFlag === 0
        ) {
          setJoinGochiKidFlag(2);
        }
      }
    }, [shopDetail]);

    const resetValue = () => {
      if (shopDetail.gochiKidFlag === 0 && shopDetail.gochiKidQrFlag === 0) {
        setJoinGochiKidFlag(0);
      } else if (
        shopDetail.gochiKidFlag === 1 &&
        shopDetail.gochiKidQrFlag === 1
      ) {
        setJoinGochiKidFlag(1);
      } else if (
        shopDetail.gochiKidFlag === 1 &&
        shopDetail.gochiKidQrFlag === 0
      ) {
        setJoinGochiKidFlag(2);
      }
      setGochiKidFlag(shopDetail.gochiKidFlag);
      setGochiKidQrFlag(shopDetail.gochiKidQrFlag);
    };

    const handleCancelConfirmDialog = value => {
      updateOpenConfirm(value);
      if (!value) {
        resetValue();
      }
    };

    const openSettingGochiKid = () => {
      handleRedirect('/settings_gochi_kid_shop');
    };
    const openReportGochiKid = () => {
      handleRedirect('/shop_report_shop');
    };
    const openListMenuGochiKid = () => {
      handleRedirect('/gochi_kid_menu_shop');
    };
    const openListMenuGochiKidFree = () => {
      handleRedirect('/gochi_kid_menu_free_shop');
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      setOpenConfirmGochiKidFlag(false);
      updateOpenConfirm(false);
      setResultMessage('');
      setLoading(false);
    };

    const handleChangeGochiKidFlag = async () => {
      updateOpenProgress(true);
      setLoading(true);
      const response = await actions
        .updateGochiKidFlagShop(account.shopId, {
          gochiKidFlag,
          gochiKidQrFlag
        })
        .then(data => checkSession(data));
      if (response.type === UPDATE_GOCHI_KID_FLAG_SHOP_SUCCESS) {
        await handleGetDetailShop();
        setLoading(false);
        setResultMessage('更新しました。');
      } else {
        setLoading(false);
        updateOpenProgress(false);
        setErrorMessage('エラーが発生しました！');
      }
    };

    const handleChangeJoinGochiKidFlag = value => {
      if (value === 0) {
        setGochiKidFlag(0);
        setGochiKidQrFlag(0);
        handleCancelConfirmDialog(true);
      } else if (value === 1) {
        setGochiKidFlag(1);
        setGochiKidQrFlag(1);
        setOpenConfirmGochiKidFlag(true);
      } else if (value === 2) {
        setGochiKidFlag(1);
        setGochiKidQrFlag(0);
        setOpenConfirmGochiKidFlag(true);
      }
      setJoinGochiKidFlag(value);
    };

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }
    return (
      <div className={classes.root}>
        <Header name={name} />
        <div className={classes.pageTitileDiv}>
          <Typography color="textPrimary" className={classes.textTitle}>
            こどもごちめし
          </Typography>
          <span className={classes.textHelpTitle}>こどもごちめし とは</span>
          <Button
            className={classes.buttonHelp}
            onClick={() => setOpenHelpGochiKid(true)}
          >
            <HelpIcon className={classes.iconHelpEx} />
          </Button>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.buttonWrapper}>
            {shopDetail && (
              <div style={{ marginTop: '19px' }}>
                <Typography
                  color="textPrimary"
                  style={{ fontWeight: 'bolder' }}
                >
                  こどもごちめし参加設定
                </Typography>
                <RadioGroup
                  value={joinGochiKidFlag}
                  onChange={e => {
                    const allowed = parseInt(e.target.value, 10);
                    handleChangeJoinGochiKidFlag(allowed);
                  }}
                  className={classes.radioGroup}
                >
                  <FormControlLabel
                    value={0}
                    control={<Radio color="primary" />}
                    label={
                      <Typography style={{ fontWeight: 'bolder' }}>
                        参加しない
                      </Typography>
                    }
                    className={classes.radioLine}
                  />
                  <FormControlLabel
                    value={1}
                    control={<Radio color="primary" />}
                    label={
                      <Typography style={{ fontWeight: 'bolder' }}>
                        参加する(カード型会員証対応あり)
                      </Typography>
                    }
                    className={classes.radioLine}
                  />
                  <FormControlLabel
                    value={2}
                    control={<Radio color="primary" />}
                    label={
                      <Typography style={{ fontWeight: 'bolder' }}>
                        参加する(カード型会員証対応なし)
                      </Typography>
                    }
                    className={classes.radioLine}
                  />
                </RadioGroup>
              </div>
            )}
            <div style={{ marginBottom: '24px' }}>
              <span className={classes.textHelpTitle}>カード型会員証とは</span>
              <Button
                className={classes.buttonHelp}
                onClick={() => setOpenHelpQrUserKid(true)}
              >
                <HelpIcon className={classes.iconHelpEx} />
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                color="primary"
                className={[classes.button]}
                onClick={openSettingGochiKid}
              >
                利用制限の設定
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                color="primary"
                className={[classes.button]}
                onClick={openReportGochiKid}
              >
                運営報告
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                color="primary"
                className={[classes.button]}
                onClick={openListMenuGochiKid}
              >
                メニュー登録
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                color="primary"
                className={[classes.button]}
                onClick={openListMenuGochiKidFree}
              >
                無料メニュー設定状況
              </Button>
            </div>
          </div>
        </Paper>

        <MenuBox account={account} />
        <div>
          <Modal open={openShopContact} className={classes.mainModal}>
            <ShopContact setOpenShopContact={setOpenShopContact} />
          </Modal>
        </div>
        <ProgressDialog
          openProgress={openProgress}
          loading={loading}
          resultMessage={resultMessage}
          progressOkAction={progressOkAction}
        />
        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
        <ConfirmDialog
          openConfirm={openConfirm}
          updateOpenConfirm={handleCancelConfirmDialog}
          message="こどもごちめし参加しないように変更しましょうか？"
          okAction={handleChangeGochiKidFlag}
        />
        <HelpGochiKidShopDialog
          openHelpGochiKid={openHelpGochiKid}
          setOpenHelpGochiKid={setOpenHelpGochiKid}
        />
        <HelpQrUserKidShopDialog
          openHelpQrUserKid={openHelpQrUserKid}
          setOpenHelpQrUserKid={setOpenHelpQrUserKid}
        />
        <ConfirmGochiKidFlagShopDialog
          openConfirmGochiKidFlag={openConfirmGochiKidFlag}
          setOpenConfirmGochiKidFlag={setOpenConfirmGochiKidFlag}
          resetValue={resetValue}
          okAction={handleChangeGochiKidFlag}
          isSmall
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
